import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import {
  NgbModal,
  ModalDismissReasons,
  NgbCheckBox,
} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';

declare const $: any;
type ListingViewMode = 'tile' | 'list';
@Component({
  selector: 'app-product-faq-create',
  templateUrl: './product-faq-create.component.html',
  styleUrls: ['./product-faq-create.component.scss']
})
export class ProductFaqCreateComponent implements OnInit {
  bearer;
  store_id;
  checkout_list = [];
  country;
  selectedCountry;
  language_name;
  isChecks = false;
  selectedProducts = [];
  mixture_data = [];
  body = {};
  urlData;
  expressUrl;
  buttonFreeze = false;
  checkout_link_id;

  filteredString: string = '';
  filteredCountry: string = '';
  activatedCountry: any[] = [];

  currentLanguage: any = [];
  languageList: any[] = [];
  filteredStatus: string = '';
  filteredStatusDisplay: string = '';
  displayedProducts = [];
  products = [];
  language_code;
  updateLink = false;
  countryFirstInit: boolean = false;
  countryLoaded: boolean = false;

  expressCheckoutData: any = [];
  expressCheckoutDataByLanguage = {};

  product_faq_title;
  product_faq_desc;

  updatingDisplayQueue = [];
  listingView: ListingViewMode = 'list';

  // Media Editor variables for text editor
  editorMediaPhotoId;
  editorImgURL;

  public initialArrangement = []; // Initially loaded or unchanged arrangement
  public productArrangement = []; // Arrangement state for current listing
  public customArrangement = {}; // Arrangement from backend, multi country
  customArrangementReady = false;
  isSavingArrangement = false;

  loading = true;
  closeResult = '';
  success = 'success';
  generateForm: FormGroup;

  productFilter: string = '';
  toggleState: boolean = false;
  quantityConfig = 0;

  buildForm() {
    const formSchema = {
      product_faq_title: ['']
    };

    this.generateForm = this.formBuilder.group(formSchema);
  }

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public utils: UtilitiesService
  ) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    this.buildForm();
    this.initContentEditor();
    this.fetchCountry();
    this.fetchProductList()
      .then(() => {
        const slug = this.activeRoute.snapshot.params.slug;
        const countryCode = this.activeRoute.snapshot.params.country_code;
        const isEditState = this.activeRoute.snapshot?.url[1]?.path === 'edit';

        if (!isEditState) {
          // Generate New Checkout
          this.updateLink = false;
          this.countryFirstInit = true;
        } else {
          this.fetchExpressCheckoutBySlug(slug, countryCode.toUpperCase())
            .then((response: any) => {
              // Update existing Checkout
              let checkoutData = response?.data?.[0] ?? {};
              let checkoutProducts = checkoutData?.product ?? '';
              checkoutProducts = JSON.parse(checkoutProducts) ?? [];

              this.checkout_link_id = checkoutData?.checkout_link_id;
              this.expressCheckoutData = response?.data ?? [];

              // Update country
              this.changeCountry(checkoutData?.country_code ?? 'MY');
              this.countryFirstInit = true;

              this.changeLanguage(checkoutData);

              // Check selected product
              checkoutProducts.forEach((product) => {
                this.insertSelectedProduct(product.product_id);
              });

              this.updateLink = true;
            })
            .catch((error) => {
              console.log('Loading checkout data error:', { error });
            });
        }
      })
      .catch((error) => {
        console.log('Loading product error:', { error });
      });
  }

  async fetchProductList() {
    this.loading = true;

    return new Promise((resolve, reject) => {
      this.svc.getStoreLanguage(this.bearer, this.store_id).subscribe(
        (res) => {
          const allLanguages = res['data'];

          const enabledLanguages = allLanguages.filter((lang) => +lang.status);
          const defaultLanguage =
            allLanguages.find((lang) => +lang.default) ?? allLanguages[0];

          this.languageList = enabledLanguages;

          this.language_code = defaultLanguage['language_code'];
          this.language_name = defaultLanguage['language_name'];

          this.changeLanguage(defaultLanguage);

          this.reloadProductList().finally(() => {
            this.generateArrangementList();
            this.loading = false;

            setTimeout(() => {
              resolve(true);
            }, 1);
          });
        },
        (error) => {
          this.loading = false;
          reject(error);
        }
      );
    });
  }

  async reloadProductList() {
    return new Promise((resolve, reject) => {
      this.svc
        .getProductLists(this.bearer, this.store_id, this.language_code)
        .subscribe(
          (res) => {
            let productList = res['data'];
            this.products = productList.filter((product) => +product.display_status === 1);
            this.loading = false;

            this.updateFilter();
            this.generateArrangementList(true);
            resolve(true);
          },
          (error) => {
            this.loading = false;
            reject(error);
          }
        );
    });
  }

  async fetchExpressCheckoutBySlug(slug, countryCode) {
    return new Promise((resolve, reject) => {
      this.svc
        .fetchExpressCheckoutBySlug(
          this.bearer,
          this.store_id,
          slug,
          countryCode
        )
        .subscribe(
          (res) => {
            this.loading = false;
            resolve(res);
          },
          (error) => {
            this.loading = false;
            reject(error);
          }
        );
    });
  }

  saveLastArrangementListChanged(arrangementList = []) {
    this.initialArrangement = arrangementList;
    let countryCode = this.getSelectedCountryCode;
    this.customArrangement[countryCode] = arrangementList;
  }

  saveProductArrangement(event) {
    this.isSavingArrangement = true;
    const body = {
      store_id: this.store_id,
      arrangement: this.productArrangement,
      country_code: this.getSelectedCountryCode,
    };

    this.svc.updateCustomArrangement(body, this.bearer).subscribe(
      (res) => {
        this.isSavingArrangement = false;
        this.saveLastArrangementListChanged(this.productArrangement);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchProductArrangement() {
    this.svc.getProductCustomArrangement(this.bearer).subscribe(
      (res) => {
        this.customArrangement = res?.['data'];
        this.sortByArrangementList();
        this.customArrangementReady = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  generateArrangementList(doSort = false) {
    let productArrangement = Object.entries(this.displayedProducts).map(
      (product: any) => +product[1].p_id
    );
    this.productArrangement = productArrangement;
    if (doSort) this.sortByArrangementList();
  }

  sortByArrangementList() {
    this.customArrangement;
    this.productArrangement;

    if (this.customArrangementReady && this.productArrangement?.length) {
      // Arrangement ready
      let countryCode = this.getSelectedCountryCode;
      let newArrangement = [...(this.customArrangement[countryCode] ?? [])];
      this.productArrangement.forEach((p_id) => {
        if (!newArrangement.includes(p_id)) {
          newArrangement.push(p_id);
        }
      });

      this.productArrangement = newArrangement;

      let arrangedProducts = [];
      newArrangement.forEach((p_id) => {
        let productFound = this.displayedProducts.find(
          (product) => +product.p_id === +p_id
        );

        // Only insert non-empty
        if (productFound) arrangedProducts.push(productFound);
      });

      // Replace displayedProducts with arrangedProducts
      this.displayedProducts = arrangedProducts;

      // Save/Reset unchanged arrangement list with new value
      this.saveLastArrangementListChanged(newArrangement);
    }
  }

  get getSelectedCountryCode(): string {
    return this.filteredCountry?.toUpperCase();
  }

  getCountryName(country_code: string) {
    country_code = (country_code || '').toLowerCase();
    const country = this.country?.find(
      (c) => (c.country_code || '').toLowerCase() === country_code
    );
    this.selectedCountry = country_code;
    return country?.country_name ?? country_code;
  }

  fetchCountry() {
    this.svc.getCountry(this.bearer).subscribe((res) => {
      res['data'].forEach((item) => {
        if (item['country_name'] == 'Malaysia-Brunei') {
          item['country_name'] = 'Brunei';
        }
      });
      let defaultCountry = res['data'].find((index) => {
        if (parseInt(index['default']) === 1) {
          return index;
        }
      });

      this.country = [{ country_code: '', country_name: '' }];
      this.filteredCountry = defaultCountry['country_code'];
      this.activatedCountry = [];
      this.countryLoaded = true;
      if (res['data']) {
        res['data'].forEach((value) => {
          value.country_name = value.country_name.split('-').pop().trim();
          this.country.push(value);
          if (+value.status === 1) {
            this.activatedCountry.push(value);
          }
        });
      }
    });
  }

  updateFilter(event = null) {
    const filteredProducts = this.filterProducts(this.products, [
      this.filteredString,
      this.filteredCountry
    ]);
    this.displayedProducts = filteredProducts;
  }

  productFilterChanged(e) {
    this.productFilter = e.target.value;
    this.updateFilter();
  }

  getDisplayedProducts() {
    return this.displayedProducts.filter((product) => {

      const keywords = this.productFilter.toLowerCase().split(' ');
      return keywords.every(
        (keyword) =>
        (product.search_key?.toLowerCase().includes(keyword) && +product.display_status === 1) ||
        (product.product_display_name?.toLowerCase().includes(keyword) && +product.display_status === 1)
      );
    });
  }

  filterProducts(products: any, filterString: any) {
    if (!products || products.length === 0) {
      return products;
    }

    return products.filter((product: any) => {
      // Filter by search query
      const keywordsFilter = filterString[0].toLowerCase().split(' ');
      const keywordsFilterResult = keywordsFilter.every(
        (keyword) => product.product_name.toLowerCase().indexOf(keyword) >= 0
      );

      // Filter by country
      const countryFilter = filterString[1];
      const countryFilterResult =
        countryFilter === '' || product['country_code'] === countryFilter;

      return (
        keywordsFilterResult &&
        countryFilterResult
      );
    });
  }

  changeCountry(countryCode) {
    this.filteredCountry = countryCode;
    this.selectedProducts = [];
    this.updateFilter();
    this.generateArrangementList(true);
  }

  changeLanguage(languageData) {
    const { languageList } = this;
    let defaultCheckoutData = this.expressCheckoutData[0] ?? {};

    if (languageData !== undefined) {
      let foundLanguage = languageList.find((language) => {
        return (
          language?.language_code?.toLowerCase() ===
          languageData?.language_code?.toLowerCase()
        );
      });

      languageData = foundLanguage;
      this.currentLanguage = languageData;
      let languageCode = (this.language_code = languageData.language_code);
      let languageName = (this.language_name = languageData.language_name);

      // Find checkout data for the requested language
      let expressCheckoutDataByLanguage = this.expressCheckoutData?.find(
        (linkData) => {
          return linkData.language_code === languageCode;
        }
      );
    
      this.updateLink = true;
      this.toggleState = false;
      this.quantityConfig = 0;

      this.generateForm
        .get('product_faq_title')
        .setValue(expressCheckoutDataByLanguage?.product_faq_title ?? '');
    }
  }

  getLanguageName(languageData) {
    return languageData.language_name;
  }

  open(content, id) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          if (result == 'delete') {
            // this.deleteLink(id);
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  get isTileView() {
    return true;
    return this.listingView === 'tile';
  }
  get isListView() {
    return this.listingView === 'list';
  }

  getProductData(productId: number) {
    return this.displayedProducts.find(
      (product) => +product.p_id === +productId
    );
  }

  getEditProductLink(productId: number) {
    const { language_code } = this;
    return `/dashboard/product/edit/${productId}/${language_code}`;
  }

  getFlagByCountryCode(country_code: string) {
    country_code = (country_code || '').toLowerCase().substr(-2, 2);
    country_code = country_code === 'cm' ? 'kh' : country_code;
    return country_code;
  }

  getFlagImageURL(country_code: string) {
    country_code = this.getFlagByCountryCode(country_code);
    return `https://cdn.estore5s.com/asset/flags/${country_code}.png`;
  }

  productClick(pid) {
    const productAlreadyInCollection = this.selectedProducts.find((product) => {
      return +product.product_id === +pid;
    });

    if (!productAlreadyInCollection) {
      this.insertSelectedProduct(pid);
    } else {
      this.removeSelectedProduct(pid);
    }
  }

  insertSelectedProduct(pid) {
    this.selectedProducts.push({
      product_id: +pid,
    });
    this.body['product'] = this.selectedProducts;
  }
  removeSelectedProduct(pid) {
    this.selectedProducts = this.selectedProducts.filter(
      (product) => +product.product_id !== +pid
    );
    this.body['product'] = this.selectedProducts;
  }

  isProductSelected(pid) {
    return this.selectedProducts.find(
      (product) => +product.product_id === +pid
    );
  }

  getErrorMessage(error = null, message = null) {
    if (error?.error?.messages?.error) {
      this.utils.notify.showError(error?.error?.messages?.error);
    } else if (error?.error?.data) {
      let err = Object.values(error?.error?.data);
      let msg = message + '\n\n';
      let i = 0;
      err.forEach((value) => {
        msg += this.utils.translate(value);
        i++;
        if (i < err.length) {
          msg += '\n';
        }
      });
      this.utils.notify.showError(msg);
    } else {
      this.utils.notify.showError(message ?? this.utils.translate("Create failed!"));
    }
    this.utils.msgBox.open({
      message: this.utils.translate(message ?? 'Create failed!'),
      title: this.utils.translate('Error'),
      icon: 'error',
      contentClassList: 'whitespace-pre-line',
    });
  }

  filterNonUrlCharacters(event) {
    let url = this.generateForm.get('url').value;
    let sanatizedUrl = url
      .trim()
      .replace(/[^a-zA-Z0-9-]/g, '')
      .replace(/--/g, '-');
    if (sanatizedUrl[0] === '-') sanatizedUrl = sanatizedUrl.substr(1);
    this.generateForm.get('url').setValue(sanatizedUrl);
  }

  /*
  Image Upload for Trumbowyg content editor
  */
  lastInsertImageCallback: Function;
  handleTrumbowygMediaChanged(event) {
    console.log('handleTrumbowygMediaChanged', { event });
    this.lastInsertImageCallback(event.url);
  }

  handleSetInsertImageCallback(event) {
    console.log('handleSetInsertImageCallback', { event });
    this.lastInsertImageCallback = event.detail.InsertImageCallback;
  }

  onToggleChange() {
    this.toggleState = !this.toggleState;
    if(this.toggleState === true){
      this.quantityConfig = 1;
    }else{
      this.quantityConfig = 0;
    }
  }

  initContentEditor() {
    let defaultButtons = $.trumbowyg.defaultOptions.btns;

    defaultButtons[3] = [
      'fontsize',
      'foreColor',
      'backColor',
    ];

    setTimeout(() => {
      $.trumbowyg.svgPath = '/library/trumbowyg-dist/ui/icons.svg';
      setTimeout(() => {
        $('.text-textarea').trumbowyg();
      }, 10);

      $(
        '#product_faq_desc.content-editor-textarea'
      ).trumbowyg({
        btns: defaultButtons,
      });
    }, 1000);
  }

  createFaq() {
    if (this.selectedProducts.length <= 0) {
      this.utils.msgBox.open({
        title: this.utils.translate('Uh oh!'),
        icon: 'warning',
        message: this.utils.translate('Please select at least 1 product.'),
      });
      return;
    }

    const languageCode = this.currentLanguage['language_code'];

    this.product_faq_title = this.generateForm.get('product_faq_title').value;
    this.product_faq_desc = $(`#product_faq_desc.content-editor-textarea`)[0].value;

    this.body['store_id'] = this.store_id;
    this.body['country_code'] = this.selectedCountry.toUpperCase();
    this.body['title'] = this.product_faq_title;
    this.body['description'] = this.product_faq_desc;
    this.body['language_code'] = languageCode;

    this.buttonFreeze = true;
    this.postCreateFaq();
  }

  postCreateFaq() {
    this.svc.postCreateFaq(this.body, this.bearer).subscribe(
      (res) => {
        this.loading = true;
        this.utils.notify.showSuccess(this.utils.translate("FAQs Successfully Created"));
        setTimeout(() => {
          this.router.navigate(['/dashboard/product-faq']);
        }, 2000);
      },
      (error) => {
        this.loading = false;
        this.utils.notify.showError(this.utils.translate("Failed to Create FAQs"));
        this.getErrorMessage(error, this.utils.translate("Failed to Create FAQs"));
        // this.toastError = true;
        this.buttonFreeze = false;
      }
    );
  }
}
